<template>
  <div id="cascader" class="el-form-item__content" style="margin-left: 0px; margin-bottom: 12px;">
  <input type="hidden" v-model="parentValue">

    <div id="cascaderWrap" ref="cascaderWrapRef" class="el-form-item__content" style="margin-left: 0px;" v-on:mouseover ="mouseOver" v-on:mouseleave = "mouseLeave">
      <div class="el-cascader el-cascader--mini" :class="{dark: this.darkMode}">
        <div class="el-input el-input--mini el-input--suffix" @click="EmptyAllStatusByCloseIcon()">
          <input type="text" readonly="readonly" autocomplete="off" class="el-input__inner" @click="toggleList(true)" :style="{height: height}">
          <span class="el-input__suffix" @click="toggleListAndItem()">
            <span class="el-input__suffix-inner">
              <i class="el-input__icon" :class="[{'is-reverse': (isShowList && excludeList.length < 1)}, {'el-icon-arrow-down': isArrowIcon}, {'el-icon-circle-close': isCloseIcon}]"></i>
            </span>
          </span>
        </div>
        <div class="el-cascader__tags" ref="tagsContainerRef" @click="autometion()">
          <span class="el-tag el-tag--info el-tag--mini el-tag--light" v-show="excludeList.length > 0">
            <span v-if="excludeList.length > 0">{{ excludeList[0]['label'] }}</span>
            <i class="el-tag__close el-icon-close" @click="decreaseItem()"></i>
          </span>
          <span class="el-tag el-tag--info el-tag--mini el-tag--light" v-show="excludeList.length > 1">
            <span>+ {{ excludeList.length > 1000 ? 999 : (excludeList.length -1) }}</span>
          </span>
          <input type="text" :placeholder="excludeList.length > 0 ? '' : '除外するリストを選択'" class="el-cascader__search-input" v-model="searchWord">
        </div>
      </div>

      <div class="el-popper" ref="popperRef"
        :class="isShowList || isShowItem || isShowSearchList ? 'el-cascader__dropdown' : ''"
        style="z-index: 10000; left: 30px; position: fixed;"
        :style="{top: targetOffsetTop + 'px'}"
        :x-placement="popperPlacement"
      >
          <div class="el-cascader-panel" v-show="isShowList" >
            <div class="el-scrollbar el-cascader-menu" role="menu" id="cascader-menu-3842-0">
              <div class="el-cascader-menu__wrap el-scrollbar__wrap" style="margin-bottom: -15px; margin-right: -15px;">

                <ul class="el-scrollbar__view el-cascader-menu__list">
                  <li role="menuitem" id="cascader-menu-8174-0-0" tabindex="-1" class="el-cascader-node in-active-path" aria-haspopup="true" aria-owns="cascader-menu-8174-0" aria-expanded="true" @click="toggleItem(true)">
                    <label class="el-checkbox" :class="{'is-checked': isAllChecked == 3 || isAllChecked == 2 ? true : false}">
                      <span class="el-checkbox__input" :class="[{'is-checked': isAllChecked == 3 || isAllChecked == 2 ? true : false}, {'is-indeterminate': isAllChecked === 2 ? true : false}]">
                        <span class="el-checkbox__inner"></span>
                        <input type="checkbox"
                          aria-hidden="false"
                          class="el-checkbox__original"
                          :name="this.options ? this.options[0].value : ''"
                          @click="toggleAllStatus">
                      </span>
                    </label>
                    <span class="el-cascader-node__label">{{ this.options ? this.options[0].label : '' }}</span>
                    <i class="el-icon-arrow-right el-cascader-node__postfix"></i>
                  </li>
                </ul>
              </div>
              <div class="el-scrollbar__bar is-horizontal"><div class="el-scrollbar__thumb" style="transform: translateX(0%);"></div></div>
              <div class="el-scrollbar__bar is-vertical"><div class="el-scrollbar__thumb" style="transform: translateY(0%);"></div></div>
            </div>
            <div class="el-scrollbar el-cascader-menu" role="menu" id="cascader-menu-4222-1">
              <div class="el-cascader-menu__wrap el-scrollbar__wrap" style="margin-bottom: -15px; margin-right: -15px;">
                <ul class="el-scrollbar__view el-cascader-menu__list">
                  <li v-for="(item, index) in list" :key="item['value']" role="menuitem" id="cascader-menu-4222-1-0" tabindex="-1" class="el-cascader-node" :class="{'is-active': item['checked']}">
                    <label class="el-checkbox" :class="{'is-checked': item['checked']}">
                      <span class="el-checkbox__input" :class="{'is-checked': item['checked']}">
                        <span class="el-checkbox__inner" :class="{'is-checked': item['checked']}"></span>
                        <input type="checkbox"
                          aria-hidden="false"
                          class="el-checkbox__original"
                          :name="index"
                          :value="item['value']"
                          :checked="item['checked']"
                          @change="toggleStatus"
                        >
                      </span>
                    </label>
                    <span class="el-cascader-node__label">{{ item['label'] }}</span>
                  </li>
                </ul>
              </div>
              <div class="el-scrollbar__bar is-horizontal">
                <div class="el-scrollbar__thumb" style="transform: translateX(0%);">
                </div>
              </div>
              <div class="el-scrollbar__bar is-vertical">
                <div class="el-scrollbar__thumb" style="transform: translateY(0%);">
                </div>
              </div>
            </div>
          </div>

          <div class="el-cascader__suggestion-panel el-scrollbar" v-show="isShowSearchList">
            <div class="el-scrollbar__wrap" style="margin-bottom: -15px; margin-right: -15px;">
              <ul class="el-scrollbar__view el-cascader__suggestion-list" style="min-width: 210px; min-height: 189px;">
                <li v-if="searchList.length == 0">
                  データなし
                <li v-for="(item, index) in searchList" :key="item['value']" tabindex="-1" class="el-cascader__suggestion-item" :class="{'is-checked':item['checked']}" @click="toggleSearchStatus(item['value'])" v-else>
                  <span>{{ item['label'] }}</span>
                  <i class="el-icon-check" v-show="item['checked']"></i>
                  <input type="checkbox" style="display:none"
                      :name="index"
                      :value="item['value']"
                      :checked="item['checked']"
                  >
                </li>
              </ul>
            </div>
            <div class="el-scrollbar__bar is-horizontal">
              <div class="el-scrollbar__thumb" style="transform: translateX(0%);">
              </div>
            </div>
            <div class="el-scrollbar__bar is-vertical">
              <div class="el-scrollbar__thumb" style="transform: translateY(0%);">
              </div>
            </div>
          </div>
          <div x-arrow="" class="popper__arrow" style="left: 35px;"></div>
        </div>

    </div>

  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    darkMode: Boolean,
    options: Array
  },
  data() {
    return {
      list: [],
      allCheckedList: [], // Allをチェックされた場合に備えて現在の除外リスト全てを保持しておく
      excludeList: [],
      searchWord: '',
      searchList: [{
        value: '',
        checked: ''
      }],
      isAllChecked: 1,
      isShowList: false,
      isShowItem: false,
      isShowSearchList: false,
      isFullReset: false,
      height: '34px',
      isArrowIcon: true,
      isCloseIcon: false,
      targetOffsetTop: 0,
      sidemenuObj: Object,
      scrollFlg: false,
      popperPlacement: null
    }
  },
  beforeUpdate : function() {
    // このフラグが必要になる可能性があるので、コメントアウトで残しておく（安定稼働したら削除する）
    // if (this.scrollFlg) {
    //   return
    // }
    // this.scrollFlg = true
    this.sidemenuObj = document.querySelector('#sidemenu')
    this.excludeList = ((typeof this.value === 'object' && this.options) ? this.options[0].children : []).filter(function(item) {
      return this.value.some(v => v[1] === item.value)
    }, this)
    this.list = (this.options ? this.options[0].children : []).map(function(item) {
      item.checked = this.excludeList.some(e => e['value'] === item.value);
      return item
    }, this)
    this.allCheckedList = this.options ? this.options[0].children.map((item) => {
      return [
        'all', item.value, item.label
      ]
    }) : []
    this.isAllChecked = 1 // 未チェック
    if (this.excludeList.length > 0) {
      this.isAllChecked = 2 // 1つ以上チェック
      if (this.excludeList.length === this.allCheckedList.length) {
        this.isAllChecked = 3 // 全てチェック
      }
    }
  },
  computed: {
    parentValue: {
      get: function() {
        return this.value
      },
      set: function(parentValue) {
        this.scrollFlg = false
        this.$emit('input', parentValue)
        this.$emit('change')
      }
    }
  },
  watch: {
    searchWord: function(word) {
      var toggleFlg = true
      var toggleSearchFlg = true
      if (word === '') {
        toggleSearchFlg = false
      } else {
        toggleFlg = false
      }
      if (this.isFullReset) {
        toggleFlg = this.isFullReset = false
      }
      this.toggleList(toggleFlg)
      this.toggleItem(toggleFlg)
      this.toggleSearchList(toggleSearchFlg)
      this.searchList = this.list.filter((item) => item.label.indexOf(word) !== -1)
      if (this.isShowSearchList) {
        this.popperPlacement = 'bottom';
        this.updateDropdownPositionWithNextTick();
      } else if (this.isShowList) {
          this.popperPlacement = 'bottom';
          this.updateDropdownPositionWithNextTick();
      }
    },
    isShowList(newVal) {
      if (newVal) {
        this.updateDropdownPositionWithNextTick();
      }
    },
    isShowItem(newVal) {
      if (newVal) {
        this.updateDropdownPositionWithNextTick();
      }
    },
    isShowSearchList(newVal) {
      if (newVal) {
        this.updateDropdownPositionWithNextTick();
      }
    },
    excludeList: {
      handler(newVal) {
        this.$nextTick(() => {
          const tagsContainer = this.$refs.tagsContainerRef;
          if (!tagsContainer || newVal.length === 0) {
            this.height = '34px';
          } else {
            const tagsHeight = tagsContainer.offsetHeight;
            const oneLineHeightThreshold = 51;
            if (tagsHeight > oneLineHeightThreshold) {
              this.height = '58px';
            } else {
              this.height = '34px';
            }            
          }
          if (this.isShowList || this.isShowItem || this.isShowSearchList) {
            this.updateDropdownPositionWithNextTick();
          }
        });
      },
      deep: true
    },
  },
  mounted: function() {
    window.addEventListener('click', this.closeCascader);
    window.addEventListener('resize', this.handleScrollOrResize);
    window.addEventListener('scroll', this.handleWindowScroll, true);
    this.sidemenuObj = document.querySelector('#sidemenu');
    this.sidemenuObj.addEventListener("scroll", this.handleScrollOrResize);
  },
  beforeDestroy: function() {
    window.removeEventListener('click', this.closeCascader);
    if (this.sidemenuObj) {
      this.sidemenuObj.removeEventListener("scroll", this.handleScrollOrResize);
    }
    window.removeEventListener('resize', this.handleScrollOrResize);
    window.removeEventListener('scroll', this.handleWindowScroll, true);
  },
  methods: {
    decreaseItem() {
      this.parentValue = this.parentValue.filter(item => item[1] !== this.excludeList[0].value)
    },
    autometion() {
      if (!this.isShowList && !this.isShowSearchList) {
        this.toggleList(true)
      }
    },
    toggleListAndItem(judge) {
      this.toggleList(judge === null ? !this.isShowList : judge)
      this.toggleItem(judge === null ? !this.isShowItem : judge)
    },
    toggleList(judge = null) {
      this.isShowList = judge === null ? !this.isShowList : judge
      const newState = judge === null ? !this.isShowList : judge;
      const shouldShow = newState || this.isShowItem;
      if (shouldShow) {
        this.isShowList = newState;
        this.popperPlacement = 'bottom';
        this.updateDropdownPositionWithNextTick();
        const intendedState = judge === null ? !(this.isShowList || this.isShowSearchList) : judge;
        if (intendedState) {
          if (this.searchWord && this.searchWord !== '') {
            this.isShowList = false;
            this.isShowItem = false;
            this.isShowSearchList = true;
          } else {
            this.isShowSearchList = false;
            this.isShowList = true;
          }
          if (this.options && this.options.length > 0 && this.options[0].children) {
            this.isShowItem = true; 
          }
        }
      } else {
        this.isShowList = false;
        this.isShowItem = false;
        this.isShowSearchList = false;
        this.popperPlacement = null;
      }
    },
    toggleItem(judge) {
      this.isShowItem = judge
    },
    toggleSearchList(judge) {
      this.isShowSearchList = judge
    },
    toggleAllStatus() {
      if (this.excludeList.length === this.allCheckedList.length) {
        this.parentValue = []
      } else {
        this.parentValue = this.allCheckedList
      }
    },
    toggleStatus(e) {
      if (e.target.checked) {
        this.parentValue.push(['all', e.target.value])
        var items = this.parentValue
        this.parentValue = items
      } else {
        this.parentValue = this.parentValue.filter(item => item[1] !== e.target.value)
      }
    },
    toggleSearchStatus(v) {
      if (this.excludeList.length === 0 || !this.excludeList.some(el => el['value'] == v)) {
        this.parentValue.push(['all', v])
        var items = this.parentValue
        this.parentValue = items
      } else {
        this.parentValue = this.parentValue.filter(item => item[1] !== v)
      }
    },
    EmptyAllStatusByCloseIcon() {
      if (this.excludeList.length > 0) {
        this.isAllChecked = false
        this.searchWord = ''
        this.parentValue = []
        this.toggleList(true)
        this.toggleItem(true)
      }
    },
    closeCascader(event) {
      if (!this.$el.contains(event.target) &&
          (this.isShowList || this.isShowItem || this.isShowSearchList)
      ) {
        this.isAllChecked = false
        this.searchWord = ''
        this.isFullReset = true
        this.toggleList(false)
        this.toggleItem(false)
        this.toggleSearchList(false)
        this.popperPlacement = null
      }
    },
    mouseOver() {
      this.scrollFlg = true
      this.isArrowIcon = this.excludeList.length > 0 ? false : true
      this.isCloseIcon = this.excludeList.length > 0 ? true : false;
    },
    mouseLeave( ){
      this.isArrowIcon = true
      this.isCloseIcon = false;
    },
    updateDropdownPosition() {
      if (this.isShowList || this.isShowItem || this.isShowSearchList) {
        const triggerRect = this.$refs.cascaderWrapRef.getBoundingClientRect();
        const popperEl = this.$refs.popperRef;
        const popperHeight = popperEl.offsetHeight;
        let newTop;
        let newPlacement;
        if (popperHeight === 0 && (this.isShowList || this.isShowItem || this.isShowSearchList)) {
          newTop = triggerRect.bottom;
          newPlacement = 'bottom';
        } else {
          const spaceBelow = window.innerHeight - triggerRect.bottom;
          const spaceAbove = triggerRect.top;
          if (spaceBelow >= popperHeight + 20) {
            newTop = triggerRect.bottom;
            newPlacement = 'bottom';
          } else if (spaceAbove >= popperHeight) {
            newTop = triggerRect.top - popperHeight - 15;
            newPlacement = 'top';
          } else {
              newTop = triggerRect.bottom;
              newPlacement = 'bottom';
          }
        }
        this.targetOffsetTop = newTop;
        this.popperPlacement = newPlacement;
      }
    },
    updateDropdownPositionWithNextTick() {
      this.$nextTick(() => {
        this.updateDropdownPosition();
      });
    },
    handleWindowScroll() {
      if (!(this.isShowList || this.isShowItem || this.isShowSearchList)) {
        return;
      }
      this.updateDropdownPositionWithNextTick();
      if (this.$refs.cascaderWrapRef) {
        const triggerRect = this.$refs.cascaderWrapRef.getBoundingClientRect();
        if (triggerRect.bottom < 0 || triggerRect.top > window.innerHeight) {
          this.closeDropdownInternally();
        }
      }
    },
    closeDropdownInternally() {
      this.toggleList(false);
      this.toggleItem(false);
      this.toggleSearchList(false);
      this.popperPlacement = null;
    },
  }
}
</script>
